import { Box, Divider, Typography } from "@mui/material";
import { Cadet } from "../../shared/types/scoreboard.types";
import { DetailItem } from "./DetailItem";
import { handleDetailKeyToString } from "../../utils/scoreboardUtils";
import React from "react";

export const RenderDetailsContent: React.FC<{ selectedCadet: Cadet | null }> = ({ selectedCadet }) => {
  return (
    selectedCadet && (
      <>
        {selectedCadet.isDisqualified && (
          <Box
            sx={{
              backgroundColor: "#ffabab",
              padding: 1,
              borderRadius: 1,
              mb: 2,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              This cadet is disqualified as they have missed 2 classes or have less than or equal to 0 total points.
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: 2,
            mb: 2,
          }}
        >
          {!selectedCadet.isDisqualified && <DetailItem label="Rank" value={selectedCadet.rank} />}
          <DetailItem label="SMD" value={selectedCadet.smd} />
          {selectedCadet.spousePartner !== "" && <DetailItem label="Spouse/Partner" value={selectedCadet.spousePartner} />}
          <DetailItem label="Total" value={selectedCadet.total.toFixed(2)} bold />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: "bold" }}>
          Class Breakdown
        </Typography>

        {["c1", "c2", "c3", "c4", "c5"].map((cycle) => (
          <Box key={cycle} sx={{ mb: 3 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: "bold", mb: 1 }}>
              {cycle.replace("c", "Class ")} Details
            </Typography>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                gap: 1.5,
              }}
            >
              {selectedCadet &&
                Object.entries(selectedCadet[cycle as keyof Cadet])
                  .filter(
                    ([key]) =>
                      key !== "total" &&
                      ((cycle !== "c3" && cycle !== "c4" && cycle !== "c5" && key !== "callout" && key !== "calloutNotes") ||
                        cycle === "c3" ||
                        cycle === "c4" ||
                        cycle === "c5")
                  )
                  .map(([key, value]) => (
                    <DetailItem
                      key={key}
                      label={handleDetailKeyToString(key, cycle)}
                      value={value !== null && typeof value === "number" ? value.toFixed(2) : value || "-"}
                      small
                    />
                  ))}
            </Box>
          </Box>
        ))}
      </>
    )
  );
};
